module.exports = __webpack_public_path__ + "static/media/avatar.81770f8e.jpg";